module.exports = __webpack_public_path__ + "img/portrait-093.db773cb2.jpg";